import React, { Component } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import ChangePasswordForm, { POLICY_VIOLATION_TITLE } from './ChangePasswordForm'
import { PASSWORD_CHANGED_EVENT } from 'lib/passwordPolicy'

// The signed-in user changes their own password (POST /change-password, jwt).
// One modal for the Header password-expiry banner and the Profile page.
// Success → message, close, and the `password-changed` event (the Header
// banner refetches its status; the session stays).

export const CHANGE_PASSWORD_PATH = '/change-password'

export const INVALID_OLD_PASSWORD_MESSAGE = 'รหัสผ่านเดิมไม่ถูกต้อง'
export const CHANGE_FAILED_MESSAGE = 'ไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาลองใหม่อีกครั้ง'
export const CHANGE_SUCCESS_MESSAGE = 'เปลี่ยนรหัสผ่านสำเร็จ'
// locked account (session opened before the lock · DECISIONS #24): only the unlock
// gives it a new password — BE msg code PasswordPolicy::PROFILE_CHANGE_LOCKED_MSG
export const ACCOUNT_LOCKED_CHANGE_CODE = 'accountLocked'
export const ACCOUNT_LOCKED_CHANGE_MESSAGE =
  'บัญชีนี้ถูกล็อก จึงเปลี่ยนรหัสผ่านไม่ได้ กรุณาติดต่อผู้ดูแลระบบเพื่อปลดล็อกบัญชี'

/** /change-password always answers HTTP 200 (TECH_SPEC §3.3). */
export function changePasswordResult(data) {
  const body = data || {}
  if (body.status === 'success') return { success: true }
  if (body.msg === 'invalidOldPassword') {
    return { success: false, serverError: INVALID_OLD_PASSWORD_MESSAGE, serverViolations: [] }
  }
  if (body.msg === ACCOUNT_LOCKED_CHANGE_CODE) {
    return { success: false, serverError: ACCOUNT_LOCKED_CHANGE_MESSAGE, serverViolations: [] }
  }
  if (body.msg === 'passwordPolicyViolation') {
    return {
      success: false,
      serverError: POLICY_VIOLATION_TITLE,
      serverViolations: Array.isArray(body.violations) ? body.violations : [],
    }
  }
  return { success: false, serverError: CHANGE_FAILED_MESSAGE, serverViolations: [] }
}

export default class ChangePasswordModal extends Component {
  state = { submitting: false, serverError: '', serverViolations: [] }

  _isMounted = false

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps) {
    // every opening starts clean
    if (this.props.visible && !prevProps.visible) {
      this.setState({ submitting: false, serverError: '', serverViolations: [] })
    }
  }

  handleSubmit = ({ old_password, new_password }) => {
    this.setState({ submitting: true, serverError: '', serverViolations: [] })
    return axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}${CHANGE_PASSWORD_PATH}`,
        { old_password, new_password },
        { headers: { Authorization: `Bearer ${this.props.accessToken}` } }
      )
      .then(
        (res) => changePasswordResult(res && res.data),
        () => ({ success: false, serverError: CHANGE_FAILED_MESSAGE, serverViolations: [] })
      )
      .then((result) => {
        if (!this._isMounted) return
        if (result.success) {
          message.success(CHANGE_SUCCESS_MESSAGE)
          this.setState({ submitting: false })
          this.props.onClose()
          window.dispatchEvent(new Event(PASSWORD_CHANGED_EVENT))
          return
        }
        this.setState({
          submitting: false,
          serverError: result.serverError,
          serverViolations: result.serverViolations,
        })
      })
  }

  render() {
    return (
      <Modal
        wrapClassName='change-password-modal'
        title='เปลี่ยนรหัสผ่าน'
        visible={this.props.visible}
        onCancel={this.props.onClose}
        footer={null}
        maskClosable={false}
        destroyOnClose
      >
        <ChangePasswordForm
          onSubmit={this.handleSubmit}
          onCancel={this.props.onClose}
          submitting={this.state.submitting}
          serverError={this.state.serverError}
          serverViolations={this.state.serverViolations}
        />
      </Modal>
    )
  }
}
